'use strict';

var chunkFVDNYYKY_js = require('./chunk-FVDNYYKY.js');
var chunkERLKLNQZ_js = require('./chunk-ERLKLNQZ.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
var b=new RegExp("(?<name>\\w*)\\[\\s*(?<index>\\d)\\s*\\]"),c=class extends Error{};function P(i){let t=i.match(b);if(t){let{name:o,index:u}=t.groups;return [o,parseInt(u)]}}function I(i,t,o){let{defaultValue:u,matched:f,ignoreInvalidPath:x}=chunkERLKLNQZ_js.c({ignoreInvalidPath:!0,defaultValue:void 0},o);for(;t.includes("][");)t=t.replace("][","].[");let y=t.split("."),e=i,s=null,l=-1,n=!1;for(let d=0;d<y.length;d++){let a=y[d];if(a in e)s=e,l=a,e=e[a];else if(a.trim().endsWith("]")){let g=P(a);if(g){let[m,r]=g;if(m in e&&(e=e[m]),Array.isArray(e))s=e,l=r,e=e[r];else if(chunkFVDNYYKY_js.a(e)&&typeof r=="number")s=e,l=r,e=[...e][r];else {n=!0;break}continue}n=!0;break}else n=!0;}if(n)if(x)e=u;else throw new c;return typeof f=="function"&&!n&&f({value:e,parent:s,indexOrKey:l}),e}

exports.a = c;
exports.b = I;
